export default "__VITE_PUBLIC_ASSET__8700185f__"